import React from 'react';

// BeamList component that renders children for each item in the list
const BeamList = ({ className, childIdField, list = [], children }) => (
  <>
    {list.map((item, index) => {
      const key = item?.[childIdField] ?? item?.id ?? item?.label ?? index;
      const childClassName = `qa-list-${index}`;

      return React.isValidElement(children)
        ? React.cloneElement(children, {
            key,
            className: children.props.className
              ? `${className} ${children.props.className} ${childClassName}`
              : `${className} ${childClassName}`,
            ...item,
            beamIndex: index,
          })
        : children;
    })}
  </>
);
export default BeamList;
